import axios from 'axios';
import { apiUrl } from './apiBase';

interface NotificationData {
  channelId: string;
  content: string;
  empresaId: string;
  metadata?: {
    type: 'card_created' | 'card_moved' | 'card_updated' | 'card_deleted' | 'flow_created' | 'flow_updated';
    flowId?: string;
    flowName?: string;
    cardId?: string;
    cardTitle?: string;
    fromEtapa?: string;
    toEtapa?: string;
    userName?: string;
  };
}

/**
 * Envia notificação automática no chat quando ocorre uma ação no sistema
 */
export const sendChatNotification = async (data: NotificationData): Promise<void> => {
  try {
    await axios.post(apiUrl('/chat/notifications'), data);
    console.log('✅ Notificação enviada no chat:', data.content);
  } catch (error) {
    console.error('❌ Erro ao enviar notificação no chat:', error);
  }
};

/**
 * Cria mensagem de notificação para card criado
 */
export const notifyCardCreated = async (
  flowId: string,
  flowName: string,
  cardTitle: string,
  userName: string,
  empresaId: string
): Promise<void> => {
  await sendChatNotification({
    channelId: `flow-${flowId}`,
    content: `📝 **${userName}** criou o card **"${cardTitle}"**`,
    empresaId,
    metadata: {
      type: 'card_created',
      flowId,
      flowName,
      cardTitle,
      userName
    }
  });

  // Também notificar no canal geral
  await sendChatNotification({
    channelId: `general-${empresaId}`,
    content: `📝 **${userName}** criou o card **"${cardTitle}"** no fluxo **${flowName}**`,
    empresaId,
    metadata: {
      type: 'card_created',
      flowId,
      flowName,
      cardTitle,
      userName
    }
  });
};

/**
 * Cria mensagem de notificação para card movido
 */
export const notifyCardMoved = async (
  flowId: string,
  flowName: string,
  cardTitle: string,
  fromEtapa: string,
  toEtapa: string,
  userName: string,
  empresaId: string
): Promise<void> => {
  await sendChatNotification({
    channelId: `flow-${flowId}`,
    content: `🔄 **${userName}** moveu **"${cardTitle}"** de **${fromEtapa}** para **${toEtapa}**`,
    empresaId,
    metadata: {
      type: 'card_moved',
      flowId,
      flowName,
      cardTitle,
      fromEtapa,
      toEtapa,
      userName
    }
  });
};

/**
 * Cria mensagem de notificação para card atualizado
 */
export const notifyCardUpdated = async (
  flowId: string,
  flowName: string,
  cardTitle: string,
  userName: string,
  empresaId: string
): Promise<void> => {
  await sendChatNotification({
    channelId: `flow-${flowId}`,
    content: `✏️ **${userName}** atualizou o card **"${cardTitle}"**`,
    empresaId,
    metadata: {
      type: 'card_updated',
      flowId,
      flowName,
      cardTitle,
      userName
    }
  });
};

/**
 * Cria mensagem de notificação para card deletado
 */
export const notifyCardDeleted = async (
  flowId: string,
  flowName: string,
  cardTitle: string,
  userName: string,
  empresaId: string
): Promise<void> => {
  await sendChatNotification({
    channelId: `flow-${flowId}`,
    content: `🗑️ **${userName}** removeu o card **"${cardTitle}"**`,
    empresaId,
    metadata: {
      type: 'card_deleted',
      flowId,
      flowName,
      cardTitle,
      userName
    }
  });
};

/**
 * Cria mensagem de notificação para fluxo criado
 */
export const notifyFlowCreated = async (
  flowId: string,
  flowName: string,
  userName: string,
  empresaId: string
): Promise<void> => {
  await sendChatNotification({
    channelId: `general-${empresaId}`,
    content: `🎉 **${userName}** criou o fluxo **"${flowName}"**`,
    empresaId,
    metadata: {
      type: 'flow_created',
      flowId,
      flowName,
      userName
    }
  });
};
